// import {store1} from '../store/index's

var DataStore = require('../store');
var store = DataStore.default

const fetchPOST = () => {
  return store.state.kamio
}


const getKecamatanAsync = () => {

  return new Promise((resolve, reject) => {
    
    fetch(store.state.url.URL_DM_REGISTER + "kecamatan", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body: JSON.stringify({
        // akses_unit : this.tipeku
      })
    })
        .then(res => res.json())
        .then(res_data => {
        
          console.log(res_data);
          
        store.state.list_kecamatan = res_data
        resolve(res_data)
    });

  })

}

const getDeskelAsync = (kecamatan_id) => {


  return new Promise((resolve, reject) => {
    fetch(store.state.url.URL_DM_REGISTER + "list", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body: JSON.stringify({
        kecamatan_id: kecamatan_id
      })
    })
        .then(res => res.json())
        .then(res_data => {
          
        store.state.list_desa = res_data
        resolve(res_data)
    });
    
  })

  // console.log(kecamatan)
}

const getKecamatan = () => {
  fetch(store.state.url.URL_DM_KECAMATAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        akses_unit : this.tipeku

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_kecamatan = res_data
    // console.log(res_data)
  })
}

const getDesKel = (id) => {
  fetch(store.state.url.URL_DM_DES_KEL + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        kecamatan_id : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_des_kel = res_data
    // console.log(res_data)
  })
}


const getTahun = () => {
  // console.log(kecamatan)
  fetch(store.state.url.URL_tahun + "list", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    }
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_tahun = res_data
      // console.log(res_data)
  });
}


module.exports = {
  fetchPOST: fetchPOST,
  getKecamatan : getKecamatan,
  getDesKel : getDesKel,
  getTahun : getTahun,

  getKecamatanAsync : getKecamatanAsync,
  getDeskelAsync : getDeskelAsync,
}